import { ItemProps } from '@@/form-components/InputList';
import { Input } from '@@/form-components/Input';
import { InputGroup } from '@@/form-components/InputGroup';
import { PortainerSelect } from '@@/form-components/PortainerSelect';
import { FormError } from '@@/form-components/FormError';

import {
  POD_SECURITY_MODE_FIELDS,
  PROFILE_OPTIONS,
  PodSecurityNamespaceEntry,
  PodSecurityProfile,
} from './types';

export function NamespaceEntryItem({
  item,
  onChange,
  error,
  disabled,
  readOnly,
  index,
}: ItemProps<PodSecurityNamespaceEntry>) {
  const fieldError =
    typeof error === 'object' && error !== null ? error : undefined;
  const displayError =
    fieldError?.namespace ??
    POD_SECURITY_MODE_FIELDS.map(({ mode }) => fieldError?.[mode]).find(
      Boolean
    );

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-wrap items-start gap-2">
        <div className="w-56">
          <Input
            value={item.namespace}
            onChange={(e) => onChange({ ...item, namespace: e.target.value })}
            placeholder="Namespace name"
            disabled={disabled}
            readOnly={readOnly}
            data-cy={`pss-namespace-${index}-name`}
          />
        </div>

        {POD_SECURITY_MODE_FIELDS.map(({ mode, label }) => (
          <InputGroup key={mode} className="w-56 shrink-0">
            <InputGroup.Addon
              as="label"
              htmlFor={`pss-namespace-${index}-${mode}`}
            >
              {label}
            </InputGroup.Addon>
            <PortainerSelect<PodSecurityProfile | undefined>
              inputId={`pss-namespace-${index}-${mode}`}
              value={item[mode]}
              options={PROFILE_OPTIONS}
              onChange={(profile) =>
                onChange({ ...item, [mode]: profile ?? undefined })
              }
              isClearable
              placeholder="Select profile"
              disabled={disabled || readOnly}
              bindToBody
              data-cy={`pss-namespace-${index}-${mode}`}
            />
          </InputGroup>
        ))}
      </div>

      {displayError && <FormError>{displayError}</FormError>}
    </div>
  );
}
